locationStr